module.exports = __webpack_public_path__ + "pencil.97cc40c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/icons/pencil.png
// module id = QIHI
// module chunks = 0